export enum BioAnalyteValueType {
  DNA = 'DNA',
  CDNA = 'CDNA',
  CFDNA = 'CFDNA',
  CTDNA = 'CTDNA',
  GDNA = 'GDNA',
  GERMLINEDNA = 'GERMLINEDNA',
  MTDNA = 'MTDNA',
  OLIGONUCLEOTIDE = 'OLIGONUCLEOTIDE',
  LIPID = 'LIPID',
  PHOSPHOLIPID = 'PHOSPHOLIPID',
  METABOLITE = 'METABOLITE',
  PEPTIDE = 'PEPTIDE',
  PROTEIN = 'PROTEIN',
  CYTOPLASMIC_PROTEIN = 'CYTOPLASMIC_PROTEIN',
  EXTRACELLULAR_PROTEIN = 'EXTRACELLULAR_PROTEIN',
  PHOSPHOPROTEIN = 'PHOSPHOPROTEIN',
  PROTEIN_COMPLEX = 'PROTEIN_COMPLEX',
  RNA = 'RNA',
  ANTISENSE_RNA = 'ANTISENSE_RNA',
  CFRNA = 'CFRNA',
  CRNA = 'CRNA',
  MIRNA = 'MIRNA',
  MRNA = 'MRNA',
  POLY_A_RNA = 'POLY_A_RNA',
  RRNA = 'RRNA',
  SHRNA = 'SHRNA',
  SIRNA = 'SIRNA',
  TOTAL_RNA = 'TOTAL_RNA',
  TRNA = 'TRNA',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
  NA_COLLECTION_TUBE = 'NA_COLLECTION_TUBE',
  ANA = 'ANA',
  ANTISMOOTH_MUSCLE = 'ANTISMOOTH_MUSCLE',
  BNP = 'BNP',
  CHEM_PANEL_CERULO_PLASM_ALPHA1_IRON = 'CHEM_PANEL_CERULO_PLASM_ALPHA1_IRON',
  CHEMISTRY_PANEL_CYSTATIN_C = 'CHEMISTRY_PANEL_CYSTATIN_C',
  CMV = 'CMV',
  COAGULATION_HYSLAW = 'COAGULATION_HYSLAW',
  CREATININE_FOR_EGFR = 'CREATININE_FOR_EGFR',
  EBV_IGM_IGG = 'EBV_IGM_IGG',
  FERRITIN = 'FERRITIN',
  FSH = 'FSH',
  HBVDNA_HCVRNACOBAS = 'HBVDNA_HCVRNACOBAS',
  HEMATOLOGY_AND_DIFFERENTIAL_PANEL = 'HEMATOLOGY_AND_DIFFERENTIAL_PANEL',
  HEMATOLOGY_PANEL_HEMOGLOBIN_A1C = 'HEMATOLOGY_PANEL_HEMOGLOBIN_A1C',
  HEP_B_CORE_HEP_B_SURF_HEP_C_AB = 'HEP_B_CORE_HEP_B_SURF_HEP_C_AB',
  HEP_B_SURFACE_AG_HEP_C_ANTIBODY = 'HEP_B_SURFACE_AG_HEP_C_ANTIBODY',
  HEPATITIS_A_IGM = 'HEPATITIS_A_IGM',
  HEPATITIS_E_IGM = 'HEPATITIS_E_IGM',
  HERPES_SIMPLEX_IGG = 'HERPES_SIMPLEX_IGG',
  HERPES_SIMPLEX_IGM = 'HERPES_SIMPLEX_IGM',
  HEV_RNA = 'HEV_RNA',
  HIV_SCREEN_AND_SUPPLMENT_CONF = 'HIV_SCREEN_AND_SUPPLMENT_CONF',
  LIVER_KID_MICRO = 'LIVER_KID_MICRO',
  TRANSFERRIN = 'TRANSFERRIN',
  URINE_CREATININE_URINE_MICROALBUMIN = 'URINE_CREATININE_URINE_MICROALBUMIN',
  URINE_PROTEIN = 'URINE_PROTEIN',
  OPTIONAL_GX = 'OPTIONAL_GX',
  PLASMA_BIOMARKER = 'PLASMA_BIOMARKER',
  DAPA_PK_PREDOSE_ZIBO_PK_PREDOSE = 'DAPA_PK_PREDOSE_ZIBO_PK_PREDOSE',
  OPTIONAL_SERUM_BIOMARKER = 'OPTIONAL_SERUM_BIOMARKER',
  OPTIONAL_URINE_BIOMARKER = 'OPTIONAL_URINE_BIOMARKER',
}
